export class DatiPignoramento {
  id: string;
  terzo: string;
  importoPrecettato: number | string;
  pignorato: boolean;
  sommaPignorata?: number | string;
  cf?: string;
  sede?: string;
  pec?: string;
  note?: string;
}
